<template>
<el-dialog
  title="登录"
  :visible.sync="showPage"
  width="80%"
  top="8vh"
  class="login-container-box"
  >
  <div class="login-container">
    <div class="card" @keydown="handleKeydown">
      <div class="main">
        <div class="login-form">
          <!-- logo -->
          <img class="login-logo-img" :src="logo_icon" alt="logo">
          <!-- 选择登录类型 -->
          <el-menu :default-active="activeLoginIndex" active-text-color="#0078D7" class="el-menu-demo" mode="horizontal" @select="handleSelectLoginType">
            <el-menu-item index="2">手机号</el-menu-item>
            <el-menu-item index="1">账号</el-menu-item>
          </el-menu>
          <!-- 账号输入 -->
          <el-form
            v-show="activeLoginIndex == '1'"
            :model="numberRuleForm"
            status-icon
            :rules="numberRuleFormRules"
            ref="numberRuleForm"
            label-width="0px"
            class="demo-ruleForm"
            label-position="right"
            
          >
            <el-form-item  label label-width="0px" prop="selectedSchoolId" size="large">
              <el-select style="width: 100%;" v-model="numberRuleForm.selectedSchoolId" placeholder="请选择学校">
                <el-option
                  v-for="item in schoolOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item  label prop="account" label-width="0px" size="large">
              <el-input
                type="text"
                v-model="numberRuleForm.account"
                autocomplete="off"
                placeholder="请输入您的账号："
              ></el-input>
            </el-form-item>
            <el-form-item  label prop="password" label-width="0px" size="large">
              <el-input
                type="password"
                v-model="numberRuleForm.password"
                autocomplete="off"
                placeholder="请输入您的密码："
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-button class="login-button" type="primary" @click="submitForm('numberRuleForm')">登录</el-button>
            </el-form-item>
          </el-form>

          <!-- 手机号输入 -->
            <el-form
             v-show="activeLoginIndex == '2'"
            :model="phoneRuleForm"
            status-icon
            :rules="phoneRuleFormRules"
            ref="phoneRuleForm"
            label-width="0px"
            class="demo-ruleForm"
            label-position="right"
          >
            <el-form-item  label prop="account" label-width="0px" size="large">
              <el-input
                type="text"
                v-model="phoneRuleForm.account"
                maxlength="11"
                clearable
                placeholder="请输入手机号："
              ></el-input>
            </el-form-item>
            <el-form-item  label prop="password" label-width="0px" size="large">
              <el-input
                type="password"
                v-model="phoneRuleForm.password"
                placeholder="请输入验证码："
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-button class="login-button" type="primary" @click="submitForm('phoneRuleForm')">登录</el-button>
            </el-form-item>
          </el-form>


          <div v-show="activeLoginIndex == '1'"  class="login-state-box"> 
            <el-checkbox v-model="rememberedPassword">记住密码</el-checkbox>
            <span class="hover-class" @click="forgetPassword">忘记密码</span>
          </div>
          <div class="other-state-box">
            <div class="other-state-title">
            </div>
            <div class="wechat-box">
              <img style="width: 30px; height: 30px;" class="hover-class" :src="wechat_icon" alt="微信">
              <span class="register-box hover-class"  @click="registerNumber">账号注册</span>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</el-dialog>

</template>

<script>
import {
  setStorage
} from "@/common/js/localstorage";

export default {
  name:'LoginDialog',
  data() {
    //验证账号格式
    var validateAccount = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入账号"));
      }
      callback();
    };
    //验证账号密码格式
    var validatePassword = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } 
      callback();
    };
    //验证手机号格式
    var validatePhone = (rule, value, callback) => {
      if (value === "") {
        
        callback(new Error("请输入手机号"));
      }
      setTimeout(() => {
          if (!(/^1[34578]\d{9}$/.test(value))) {
            callback(new Error('手机号码格式错误'));
          }else {
              callback();
          }
      }, 1000);
    };
    return {
      showPage: false,
      default_icon: require("@/common/icon/login/logo.png"),
      logo_icon:  require("@/common/icon/login/logo.png"),
      wechat_icon:  require("@/common/icon/login/wechat.png"),
      //账号登录
      numberRuleForm: {
        selectedSchoolId:"",
        account: "",
        password: ""
      },
      numberRuleFormRules: {
        account: [{ validator: validateAccount, trigger: "blur" }],
        password: [{ validator: validatePassword, trigger: "blur" }],
        selectedSchoolId:  [{ required: true, message: '请选择学校', trigger: 'change' }],
      },
      //手机号登录
      phoneRuleForm: {
        selectedSchoolId:"",
        account: "",
        password: ""
      },
      phoneRuleFormRules: {
        account: [{ validator: validatePhone, trigger: "blur" }],
        password: [{ validator: validatePassword, trigger: "blur" }]
      },
      //学校列表
      schoolOptions:[
        {
          id: 1,
          name:"海昇教育公司"
        },
        {
          id: 2,
          name:"海昇科技有限公司"
        },
      ],
      //登录方式
      activeLoginIndex: "1",
      //记住密码
      rememberedPassword: true,
    };
  },
  computed: {},
  created() {},
  mounted() {
     this.$bus.$on('showLogin', () => {
      this.showPage = true;
    })
  },
  watch: {},
  methods: {
    /**********交互事件***********/
    //选择登录方式
    handleSelectLoginType(key, keyPath) {
        console.log(key, keyPath);
        //改变选择的登录方式
        switch( keyPath[0] ) {
          case "1": 
            this.activeLoginIndex = "1";
            break;
          case "2": 
            this.activeLoginIndex = "2";
            break;
          default: 
            this.activeLoginIndex = "1";
          break;
        }
        console.log("选择的登录方式："+ this.activeLoginIndex);
        //重置输入框
        this.resetForm('numberRuleForm');
        this.resetForm('phoneRuleForm');
    },
    //回车
    handleKeydown() {
      // 13为回车键
      if (event.keyCode == 13) {
        // 调用
        this.submitForm("ruleForm");
      }
    },
    //点击登录
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          console.log("点击了登录按钮");
          let userInfo = {
            id: 1,
            name: "李白"
          }
          setStorage("user", userInfo);
          this.$bus.$emit('checkLoginStatus')
          this.showPage = false;
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    //点击重置
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    //点击忘记密码
    forgetPassword(){
      console.log("点击了忘记密码了");
      alert("点击了忘记密码了");
    },
    //注册账号
    registerNumber(){
      //页面跳转到注册页面
      this.$router.push("/register");
    }
  }
};
</script>

<style scoped lang="stylus">
/deep/ .el-dialog__body{
  padding: 0;
}
/deep/ .el-dialog__header{
  font-weight: bold;
}
.login-container {
  width : 100%;
  height : 70vh;
  //background: url('~@/common/icon/login/background.png');
  background-clip: border-box;
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-size: 100% 100%;

  .card {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;

    .main {
      // min-width: 1200px;
      // min-height: 760px;
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      background: url('~@/common/icon/login/forword.png');
      background-repeat: no-repeat;
      background-size: 100% 100%;
      position: relative;

      .graypic {
        -webkit-filter: grayscale(100%);
        -moz-filter: grayscale(100%);
        -ms-filter: grayscale(100%);
        -o-filter: grayscale(100%);
        filter: grayscale(100%);
        filter: gray;
      }
    }
    //登录表单
    .login-form {
      width : 36%;
      background-color: #ffffff;
      border-radius: 4px;
      position: absolute;
      right : 10%;

      .login-logo-img{
        width : 50%;
      }

      //设置选择方式居中
      /deep/ .el-menu-demo{
        display: flex;
        flex-flow: row;
        justify-content: center;
        border: none;
        margin-bottom: 10px;
        height : 40px;
      }

      //输入表单
      .el-form {
        padding: 0px 30px;
        .title {
          margin: 60px 0px;
          font-size: 30px;
          font-weight: bold;
          letter-spacing: 5px;
          color: #559af8;
        }

        .el-form-item {
          max-width: 100%;
          min-width: 240px;
          position: relative;
        }


        .login-button {
          width: 100%;
          background-color: #559af8;
          border-radius : 16px;
          letter-spacing : 10px;
        }
      }
      //记住密码
      .login-state-box{
        display: flex;
        justify-content: space-between;
        padding: 0 30px;
        color : #999999;
      }
      //其他方式登录
      .other-state-box{
        padding: 10px 30px;
        .other-state-title{
          width : 100%;
          border-top:1px #ccc dashed;
          margin-bottom :10px;
        }
      }
      .wechat-box{
        display: flex;
        justify-content: center;
        color : #999999;
      }
      //注册账号
      .register-box{
        position: absolute;
        right : 30px;
        bottom : 10px;
      }
      //公用hover样式
      .hover-class:hover{
        cursor: pointer;
        color : #0078D7;
      }
    }
  }
}
</style>
